import { getApiErrorMessage } from "utils/errors";

export default function handleErrorForThunk(err) {
  return { error: getApiErrorMessage(err, "Error") };
}
